module.exports = __webpack_public_path__ + "img/about_09.5faf0a8d.png";